<template>
  <div class="loading-container">
    <div 
      class="loading-spinner" 
      :style="{ width: size + 'px', height: size + 'px' }"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  props: {
    size: {
      type: [Number, String],
      default: 24,
      validator: (value) => {
        // 验证size是否为数字或可转换为数字的字符串
        const num = Number(value)
        return !isNaN(num) && num > 0
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* loading样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.loading-spinner {
  border: 2px solid rgba(64, 158, 255, 0.2);
  border-top: 2px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
